import * as yup from 'yup';

import { validateCPF } from './cpf';
import { validateTel } from './tel';
import { validateZipCode } from './zipCode';
import { validateDate } from './date';

yup.addMethod(yup.string, 'cpf', function method(message: string) {
  // @ts-ignore
  return this.test('cpf', message || 'Número de CPF inválido', validateCPF);
});

yup.addMethod(yup.string, 'tel', function method(message: string) {
  // @ts-ignore
  return this.test('tel', message || 'Telefone inválido', validateTel);
});

yup.addMethod(yup.string, 'zipCode', function method(message: string) {
  // @ts-ignore
  return this.test('zipCode', message || 'CEP inválido', validateZipCode);
});

yup.addMethod(
  yup.string,
  'date',
  function method(message: string, [minDate, maxDate]: number[] = [18, 120]) {
    return this.test('date', message || 'Data inválida', function test(value) {
      // @ts-ignore
      return validateDate(this, value, [minDate, maxDate]);
    });
  },
);
